import { createSlice } from '@reduxjs/toolkit';

import {
    DELETE_THUMBNAIL,
    DELETE_THUMBNAIL_FAILURE,
    DELETE_THUMBNAIL_SUCCESS,
    FETCH_PRODUCT_THUMBNAIL,
    FETCH_PRODUCT_THUMBNAIL_FAILURE,
    FETCH_PRODUCT_THUMBNAIL_SUCCESS,
    INITIALIZE_FORM,
    RESET,
    UPLOAD_THUMBNAIL,
    UPLOAD_THUMBNAIL_FAILURE,
    UPLOAD_THUMBNAIL_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    uploadThumbnail: {
        isLoading: false,
        errors: null,
    },
    productThumbnail: {
        isLoading: false,
        data: null,
        error: null,
    },
    deleteThumbnail: {
        isLoading: false,
        error: null,
    },
};

const productThumbnailSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [DELETE_THUMBNAIL]: (state) => {
            state.deleteDatasheet.isLoading = true;
        },
        [DELETE_THUMBNAIL_FAILURE]: (state, action) => {
            state.deleteDatasheet = {
                ...state.deleteDatasheet,
                error: action.payload,
                isLoading: false,
            };
        },
        [DELETE_THUMBNAIL_SUCCESS]: (state) => {
            state.deleteDatasheet.isLoading = false;
        },
        [FETCH_PRODUCT_THUMBNAIL]: (state) => {
            state.productDatasheets.isLoading = true;
        },
        [FETCH_PRODUCT_THUMBNAIL_FAILURE]: (state, action) => {
            state.productDatasheets = {
                ...state.productDatasheets,
                error: action.payload,
                isLoading: false,
            };
        },
        [FETCH_PRODUCT_THUMBNAIL_SUCCESS]: (state, action) => {
            state.productDatasheets = {
                ...state.productDatasheets,
                data: action.payload,
                error: null,
                isLoading: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [UPLOAD_THUMBNAIL]: (state) => {
            state.uploadThumbnail.isLoading = true;
        },
        [UPLOAD_THUMBNAIL_FAILURE]: (state, action) => {
            state.uploadThumbnail = {
                ...state.uploadThumbnail,
                errors: action.payload,
                isLoading: false,
            };
        },
        [UPLOAD_THUMBNAIL_SUCCESS]: (state) => {
            state.uploadThumbnail.isLoading = false;
        },
    },
});

export const productThumbnailActions = productThumbnailSlice.actions;

export default productThumbnailSlice.reducer;
